/**
 * @typedef {import('./FinancesProps').default} Props
 */
import { Redirect } from 'react-router-dom';
import { translate } from '../../../App/Internationalization';
import { withBreakpoint } from '../../../shared/BreakpointProvider';
import { withSettings } from '../../../shared/SettingProvider/SettingProvider';
import AgentCard from '../../../App/Homeowner/shared/AgentCard';
import BaseHero from '../../../shared/BaseHero';
import ComparableMarketCard from '../../../App/Homeowner/shared/ComparableMarketCard';
import flags from '../../../shared/Flags';
import images from '../../../config/local/images';
import MortgageInformationCard from './MortgageInformationCard';
import paths from '../../../config/local/paths';
import PriceHistoryCard from '../../../App/Homeowner/Finances/PriceHistoryCard';
import PropertyValuation from './PropertyValuations';
import React from 'react';
import SeeWhatYouCanGet from '../../../App/shared/HomeValue/SeeWhatYouCanGet';
import TierGate from '../../../shared/TierGate';
import TaxHistoryCard from '../../../App/Homeowner/Finances/TaxHistoryCard';

/** @extends {React.Component<Props>} */
class Finances extends React.Component {
	/**  @returns {JSX.Element} */
	render() {
		if (
			!this.props.settings.isEnabled(
				flags.homeowner.financesPage,
				'homeowner_tier'
			)
		) {
			return <Redirect to={paths.app.homeowner.dashboard} />;
		}

		const components = {
			agent: (
				<TierGate
					fallback={null}
					flag={flags.branding.homeownerFinances}
					userTier="homeowner_tier"
				>
					<AgentCard key="homeowner-dashboard-agent" />
				</TierGate>
			),
			avms: <PropertyValuation key="homeowner-dashboard-avms" />,
			comps: (
				<TierGate
					fallback={null}
					flag={flags.homeowner.comparableMarketActivity}
					userTier="homeowner_tier"
				>
					<ComparableMarketCard key="homeowner-dashboard-comps" />
				</TierGate>
			),
			marketValue: (
				<SeeWhatYouCanGet key="homeowner-dashboard-marketValue" />
			),
			mortgage: (
				<TierGate
					fallback={null}
					flag={flags.homeowner.mortgageInformation}
					userTier="homeowner_tier"
				>
					<MortgageInformationCard key="homeowner-dashboard-mortgage" />
				</TierGate>
			),
			priceHistory: (
				<PriceHistoryCard key="homeowner-dashboard-priceHistory" />
			),
			taxHistory: <TaxHistoryCard key="homeowner-dashboard-taxHistory" />,
		};

		const hero = images.homeowners.finances.header;
		const title = translate('homeowner.pages.finances.title');

		if (this.props.isBelowBreakpoint) {
			return (
				<React.Fragment>
					<BaseHero heroImageUrl={hero} title={title} />
					<section className="app-block-list">
						{components.avms}
						{components.marketValue}
						{components.agent}
						{components.comps}
						{components.mortgage}
						{components.taxHistory}
						{components.priceHistory}
					</section>
				</React.Fragment>
			);
		}

		return (
			<React.Fragment>
				<h1 className="hl-ms-4 my-3">{title}</h1>

				<section className="app-responsive-area app-responsive-sidebar-grid">
					<section className="responsive-main app-block-list">
						{components.avms}
						{components.comps}
						{components.taxHistory}
						{components.priceHistory}
					</section>

					<section className="responsive-secondary app-block-list">
						<figure>
							<img alt="" className="illustration" src={hero} />
						</figure>

						{components.marketValue}
						{components.agent}
						{components.mortgage}
					</section>
				</section>
			</React.Fragment>
		);
	}
}

export default withBreakpoint(withSettings(Finances));
